<!-- 库房报损 -->
<template>
    <div>
        <div>
            <div class="demo-drawer__content data_action_form">
                <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
                    <v-tabs v-if="tabForm" :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val) => { showTabs = val }"
                            @tabHeight="(val) => { mxHeight = val }">
                        <template slot="tabs" slot-scope="scope">
                            <!-- 主要信息 -->
                            <div v-if="scope.index == 0 && scope.row.isShowForm != 1">
                                <el-form label-width="110px" id="mainInfo" class="baseForm" :show-message="false" :model="sendDataInfo" ref="sendDataInfo" size="mini">
                                    <el-row v-if="dataActionBox.actionType != 2">
                                        <el-form-item :label="formOneValue.showField" v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey" v-if="formOneValue.isShow == 1"
                                                      :prop="formOneValue.entityField" :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []">
                                            <df-date :isdisabled="formOneValue.isChange == 0" v-if="formOneValue.fieldType == 'date'" v-model="sendDataInfo[formOneValue.entityField]"></df-date>
                                            <!-- 检索方案 -->
                                            <el-tooltip v-else-if="formOneValue.fieldType == 'search'" class="item"
                                                        :disabled="sendDataInfo[formOneValue.entityField] == null || sendDataInfo[formOneValue.entityField] == '' ? true : false || sendDataInfo[formOneValue.entityField].length <= 9"
                                                        effect="dark" :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
                                                <el-input clearable v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                                          @keyup.enter.native="openSearch(formOneValue.searchId, formOneValue.isIndex, formOneValue.entityField, formOneValue.setField, formOneValue.focusField)"
                                                          :disabled="formOneValue.isChange == 0 ">
                                                    <el-button @click="openSearch(formOneValue.searchId, formOneValue.isIndex, formOneValue.entityField, formOneValue.setField, formOneValue.focusField)" slot="append"
                                                               icon="el-icon-search" :disabled="formOneValue.isChange == 0">
                                                    </el-button>
                                                </el-input>
                                            </el-tooltip>
                                            <!-- formatter下拉选 -->
                                            <el-select clearable size="mini" v-else-if="formOneValue.fieldType == 'formatter'" :disabled="formOneValue.isChange == 0" @change="$forceUpdate()"
                                                       v-model="sendDataInfo[formOneValue.entityField]" placeholder="请选择">
                                                <el-option v-for="matItem in JSON.parse(formOneValue.formatterContent)" :key="matItem.key" :label="String(Number(matItem.key)) == 'NaN' ? matItem.key : matItem.value"
                                                           :value="String(Number(matItem.key)) == 'NaN' ? matItem.value : matItem.key">
                                                </el-option>
                                            </el-select>
                                            <el-input v-else v-model.trim="sendDataInfo[formOneValue.entityField]" :disabled="formOneValue.isChange == 0"></el-input>
                                        </el-form-item>
                                    </el-row>
                                    <el-row v-if="dataActionBox.actionType == 2">
                                        <el-form-item :label="formOneValue.showField + ':'" v-if="formOneValue.isShow == 1" v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey">
                                            <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField) + ':'"></label>
                                            <span v-if="formOneValue.isRift == 1">
                                                <a @click="toDetail(sendDataInfo[formOneValue.riftField])">{{
                                       sendDataInfo[formOneValue.entityField] }}</a>
                                            </span>
                                            <span v-else-if="formOneValue.fieldType == 'date'">
                                                <span v-if="sendDataInfo[formOneValue.entityField]">
                                                    {{ $common.getLocalTime(sendDataInfo[formOneValue.entityField]) }}
                                                </span>
                                            </span>
                                            <span v-else-if="formOneValue.fieldType == 'formatter'">{{
													getValue(sendDataInfo[formOneValue.entityField],
														formOneValue.entityField, formOneValue.fieldType,
														formOneValue.formatterContent) }}</span>
                                            <span v-else>{{ sendDataInfo[formOneValue.entityField] }}</span>
                                        </el-form-item>
                                    </el-row>
                                </el-form>
                                <!-- 明细 -->
                                <el-form :inline="true" size="mini">
                                    <div id="operateBtn" v-if="dataActionBox.actionType != 2">
                                        <el-button type="primary" size="mini" @click="addDetails()">新增</el-button>
                                        <el-button type="primary" size="mini" @click="deleteDetails()">删除
                                        </el-button>
                                    </div>
                                    <el-table size="mini" ref="mxTableRef" id="mxTable" :data="sendDataInfo.lackregisterAddList" border style="width: 100%" :height="mxHeight">
                                        <el-table-column label="选择操作" width="80" v-if="dataActionBox.actionType != 2">
                                            <template slot-scope="scope">
                                                <el-radio v-model="selectedDetailsIndex" :label="scope.$index" border size="mini">
                                                    <i class="el-icon-thumb"></i>
                                                </el-radio>
                                            </template>
                                        </el-table-column>
                                        <el-table-column align="center" :prop="formOneValue.entityField" :label="formOneValue.showField" show-overflow-tooltip :min-width="formOneValue.fieldWeight"
                                                         v-for="(formOneValue, formOneKey) in mxForm" :key="formOneKey" v-if="formOneValue.isShow == 1">
                                            <template slot-scope="scope">
                                                <!-- 商品 -->
                                                <el-input :ref="formOneValue.entityField" v-if="formOneValue.entityField == 'bgmName' && dataActionBox.actionType != 2"
                                                          v-model.number="sendDataInfo.lackregisterAddList[scope.$index].bgmName"
                                                          @keyup.enter.native="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, formOneValue.setField,formOneValue.focusField,true)" clearable>
                                                    <el-button @click="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, formOneValue.setField,formOneValue.focusField,true)" slot="append"
                                                               icon="el-icon-search"></el-button>
                                                </el-input>
                                                <el-input :ref="formOneValue.entityField" v-else-if="formOneValue.fieldType == 'search' && dataActionBox.actionType != 2"
                                                          v-model.number="sendDataInfo.lackregisterAddList[scope.$index][formOneValue.entityField]"
                                                          @keyup.enter.native="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, formOneValue.setField, formOneValue.setField,formOneValue.focusField,true)"
                                                          clearable>
                                                    <el-button @click="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, formOneValue.setField, formOneValue.setField,formOneValue.focusField,true)"
                                                               slot="append" icon="el-icon-search"></el-button>
                                                </el-input>
                                                <!-- 报损数量 -->
                                                <el-input :ref="formOneValue.entityField" v-else-if="formOneValue.entityField == 'wolrRegnumber' && dataActionBox.actionType != 2"
                                                          v-model.number="sendDataInfo.lackregisterAddList[scope.$index][formOneValue.entityField]" @keyup.enter.native="tableNextFocus(formOneValue.focusField,scope.$index)"
                                                          type="number">
                                                </el-input>
                                                <!-- 有效期 -->
                                                <span v-else-if="formOneValue.fieldType == 'date'">
                                                    <span v-if="scope.row[formOneValue.entityField]">
                                                        {{ $common.getLocalTime(scope.row[formOneValue.entityField]) }}
                                                    </span>
                                                </span>
                                                <span v-else-if="formOneValue.isRift == 1">
                                                    <a @click="toDetail(scope.row[formOneValue.riftField])">{{
                                          scope.row[formOneValue.entityField]
                                       }}</a>
                                                </span>
                                                <span v-else>
                                                    {{ sendDataInfo.lackregisterAddList[scope.$index][formOneValue.entityField] }}
                                                </span>
                                            </template>
                                        </el-table-column>

                                    </el-table>
                                </el-form>
                            </div>
                        </template>
                    </v-tabs>
                </el-card>
                <v-foot :actionType="dataActionBox.actionType" :footForm="footForm" :btnFlag="true" :sendDataInfo="sendDataInfo" @initActionBox="initActionBox" @sendDataAction="sendDataAction"
                        @showPrintPlan="showPrintPlan"></v-foot>
            </div>
        </div>
        <!-- 检索方案弹窗 -->
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body='true' :append-to-body="true">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
        <printPlan ref="printPlan"></printPlan>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from "number-precision";
import SearchScheme from "../byComponents/SearchScheme.vue";
export default {
    name: "stockRegisterAction",
    props: ["actionData"],
    //import引入的组件需要注入到对象中才能使用
    components: {
        SearchScheme,
    },
    data() {
        //这里存放数据
        return {
            dataActionBox: {
                showStatus: false,
                openMode: "ltr" || "rtl",
                boxTitle: "新增" || "编辑",
                actionType: 0, // 0新增，1修改
            },
            detailsFlag: false,
            sendDataInfo: {},
            detaislDataInfo: {},
            selectGoodsInfo: "",
            showTabs: "",
            formDataList: [],
            parentSearchData: {},
            seTitle: "", //检索
            DialogVisible: false,
            seWidth: "0",
            seId: 0,
            selectedDetailsIndex: 0, //选择索引
            focusIndex: 0, //检索焦点索引
            mxHeight: 0,
            tabForm: [],
            mxForm: [],
            footForm: [],
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
    },
    //方法集合
    methods: {
        getValue(val, type, fieldType, arr) {
            var str = ""
            if (type == 'smIntype') {
                this.dictionariesDatas.forEach(item => {
                    if (item.diValue === val) {
                        str = item.diName
                    }
                })
            } else if (fieldType == 'formatter') {
                if (arr) {
                    JSON.parse(arr).forEach(item => {
                        if (String(Number(item.value)) != NaN && item.value === val) {
                            str = item.key
                        } else if (String(Number(item.key)) != NaN && item.key === val) {
                            str = item.value
                        }
                    })
                }
            } else {
                str = val || ""
            }
            return String(str)
        },
        showPrintPlan() {
            // 打印方法
            // 调用全局方法 判断Websocket是否连接
            if (this.$printSocketApi.printExeMsg() != false) {
                // 选中的数据
                this.$refs.printPlan.openDia(
                    this.actionData.orderId,
                    this.actionData.printSouce,
                    this.actionData.printJurId
                );
            } else {
                return;
            }
        },
        // 子组件穿透方法
        toDetail(orderId) {
            if (this.dataActionBox.actionType != 2)
                this.$parent.$parent.toDetail(orderId);
            else this.$parent.$parent.$parent.toDetail(orderId);
        },
        // 检索Id, 索引(表格中), 标识
        openSearch(sId, index, type, sField, fField, flag) {
            this.DialogVisible = true;
            this.seId = sId;
            this.seIndex = index;
            this.seType = type;
            this.sField = sField;
            this.fField = fField;
            if (flag) {
                this.detailsFlag = flag
                this.parentSearchData[type] = this.sendDataInfo.lackregisterAddList[index][type]

            } else {
                this.detailsFlag = false
                this.parentSearchData[type] = this.sendDataInfo[type]
            }
        },
        //检索带回数据
        changeInputModel(val) {
            console.log("返hui", val, this.sendDataInfo.lackregisterAddList);
            if (val != "" || val != undefined) {
                this.DialogVisible = false; //关闭商品检索窗口
                if (this.seType == "bgmName") {
                    if (val.length > 0) {
                        this.bgmSelect(val);
                        return;
                    }
                    Object.keys(val).forEach(key => {
                        this.$set(this.sendDataInfo.lackregisterAddList[this.seIndex], key, val[key])
                    })
                    this.tableNextFocus("wolrRegnumber", this.seIndex);
                } else {
                    this.paramValue(val)
                }
            }
        },
        bgmSelect(val) {
            var mx = JSON.parse(JSON.stringify(val))
            this.sendDataInfo.lackregisterAddList.forEach((item, index) => {
                if (item.bgmId == "" || item.bgmId == null || item.bgmId == undefined || item.bgmName == "" || item.bgmName == null || item.bgmName == undefined) {
                    this.sendDataInfo.lackregisterAddList.splice(index, 1)
                }
            })
            if (this.sendDataInfo.lackregisterAddList.length == 0) {
                mx.forEach(item => {
                    var obj = {}
                    Object.keys(item).forEach(key => {
                        this.$set(obj, key, item[key])
                    })
                    this.sendDataInfo.lackregisterAddList.push(obj)
                })
            } else {
                mx.forEach(item => {
                    var obj = {}
                    Object.keys(item).forEach(key => {
                        this.$set(obj, key, item[key])
                    })
                    this.sendDataInfo.lackregisterAddList.push(obj)
                })
            }
            this.selectedDetailsIndex = this.sendDataInfo.lackregisterAddList.length - 1
            this.tableNextFocus("wolrRegnumber", this.selectedDetailsIndex);
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(",");
            if (this.detailsFlag) {
                arr.forEach((item) => {
                    this.$set(this.sendDataInfo.lackregisterAddList[this.seIndex], item, val[item])
                });
                this.$nextTick(() => {
                    this.tableNextFocus("wolrRegnumber", this.seIndex);
                });
            } else {
                arr.forEach((item) => {
                    this.$set(this.sendDataInfo, item, val[item])
                });
            }
        },
        getSeWidth(e) {
            this.seWidth = e + "%";
        },
        getSearchName(e) {
            this.seTitle = e;
        },

        // 确认新增
        async sendDataAction(formName) {
            let flag = false;
            this.$refs[formName].validate((valid) => {
                if (valid) {
                } else {
                    this.$message({
                        message: "请完善必填信息",
                        type: "error",
                    });
                    flag = true;
                    return false;
                }
            });
            if (flag) return false;
            //检查每个明细的报损数量
            let numFlag = this.sendDataInfo.lackregisterAddList.every(
                (v) => v.wolrRegnumber > 0
            );
            if (!numFlag) {
                this.$message({
                    message: "缺货数量必须大于0",
                    type: "error",
                });
                return false;
            }
            let sendData = JSON.parse(JSON.stringify(this.sendDataInfo));
            if (this.dataActionBox.actionType == 0) {
                var responseData = await this.$http.woApplyaddBatchLack(sendData);
            } else {
                var responseData = await this.$http.setShortageRegistration(sendData);
            }
            if (responseData.status == 200) {
                this.init();
                this.$message({
                    message: "操作成功",
                    type: "success",
                });
                this.$emit("drawerCancel", 1);
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        //取消新增
        initActionBox(formName) {
            this.$confirm("确定取消吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.init();
                    this.$emit("drawerCancel", 0);
                    this.$refs[formName].resetFields();
                })
                .catch(() => { });
        },

        async isShowData(name, value) {
            this.sendDataInfo[name] = value;
        },
        //新增明细
        addDetails() {
            //bgmId
            var flag = false;
            if (this.sendDataInfo.lackregisterAddList.length > 0) {
                this.sendDataInfo.lackregisterAddList.forEach((item) => {
                    if (item.bgmId == "") {
                        flag = true;
                        this.$nextTick(() => {
                            this.selectedDetailsIndex = Number(
                                this.sendDataInfo.lackregisterAddList.length - 1
                            );
                            this.tableNextFocus("bgmName", this.selectedDetailsIndex);
                            let refsElTable = this.$refs.mxTableRef;
                            refsElTable.clearSelection();
                            refsElTable.toggleRowSelection(
                                this.sendDataInfo.lackregisterAddList[
                                this.selectedDetailsIndex
                                ]
                            );
                        });
                    }
                });
            }
            if (flag) {
                return;
            }
            this.sendDataInfo.lackregisterAddList.push({});
            var index = this.sendDataInfo.lackregisterAddList.length - 1;
            for (const key in this.detaislDataInfo) {
                this.$set(
                    this.sendDataInfo.lackregisterAddList[index],
                    key,
                    this.detaislDataInfo[key]
                );
            }
            this.$nextTick(() => {
                this.selectedDetailsIndex = Number(
                    this.sendDataInfo.lackregisterAddList.length - 1
                );
                this.tableNextFocus("bgmName", this.selectedDetailsIndex);
                let refsElTable = this.$refs.mxTableRef;
                refsElTable.clearSelection();
                refsElTable.toggleRowSelection(
                    this.sendDataInfo.lackregisterAddList[this.selectedDetailsIndex]
                );
            });
        },
        // 表格切换焦点方法
        tableNextFocus(field, index) {
            this.seIndex = index;
            if (field == "keydown") {
                if (this.sendDataInfo.lackregisterAddList[index + 1] != undefined) {
                    this.$refs["bgmName"][index + 1].focus();
                    this.selectedDetailsIndex = index + 1;
                    this.$nextTick(() => {
                        let refsElTable = this.$refs.mxTableRef;
                        refsElTable.clearSelection();
                        refsElTable.toggleRowSelection(
                            this.sendDataInfo.lackregisterAddList[this.selectedDetailsIndex]
                        );
                    });
                    return;
                }
                this.addDetails("sendDataInfo");
                return;
            }
            this.$refs[field][index].focus();
        },
        //删除明细
        deleteDetails() {
            if (this.sendDataInfo.lackregisterAddList.length < 1) {
                this.$message({
                    message: "请先添加明细",
                    type: "error",
                });
                return false;
            }
            this.sendDataInfo.lackregisterAddList.splice(this.selectedDetailsIndex, 1);
            this.selectedDetailsIndex = 0;
        },
        // 初始化
        init() {
            for (let key in this.sendDataInfo) {
                this.sendDataInfo[key] = "";
            }
            this.sendDataInfo.lackregisterAddList = [];
        },
        //父级传入
        openBox() {
            this.dataActionBox.actionType = this.actionData.cate;
            this.formDataList = this.actionData.formData;
            var oldData = this.actionData.oldData;
            this.filterMainField();
            if (this.dataActionBox.actionType == 0) {
                this.dataActionBox.boxTitle = "新增信息";
                this.dataActionBox.openMode = "ltr";
            } else if (this.dataActionBox.actionType == 1) {
                this.dataActionBox.boxTitle = "编辑信息";
                this.dataActionBox.openMode = "rtl";
                var dataInfo = JSON.parse(JSON.stringify(oldData));
                for (let key in dataInfo) {
                    this.$set(this.sendDataInfo, key, dataInfo[key]);
                }
                this.$set(this.sendDataInfo, "lackregisterAddList", []);
                dataInfo.lossdetailInfos.forEach(async (item, keys) => {
                    this.sendDataInfo.lackregisterAddList.push(item);
                });
            } else {
                this.dataActionBox.boxTitle = "查看信息";
                var dataInfo = JSON.parse(JSON.stringify(oldData));
                for (let key in dataInfo) {
                    this.$set(this.sendDataInfo, key, dataInfo[key]);
                }
                this.$set(this.sendDataInfo, "lackregisterAddList", []);
                dataInfo.lossdetailInfos.forEach(async (item, keys) => {
                    this.sendDataInfo.lackregisterAddList.push(item);
                });
            }

            this.$nextTick(() => {
                setTimeout(() => {
                    if (this.dataActionBox.actionType != 2) {
                        this.mxHeight = this.$common.getBtnHeight();
                    } else {
                        this.mxHeight = this.$common.getHeight();
                    }
                }, 16.7);
            });
        },
        // 过滤表单不同类型
        filterMainField() {
            var mainFormList = [];
            this.formDataList.forEach((item) => {
                if (item.jciType == 1) {
                    mainFormList.push(item);
                } else if (item.jciType == 2) {
                    this.mxForm = JSON.parse(JSON.stringify(item.jurconfigform));
                    this.mxForm.forEach((item1) => {
                        if (item1.fieldType == "number") {
                            this.$set(this.detaislDataInfo, item1.entityField, 0);
                        } else if (item1.fieldType == "search" && item1.setField) {
                            var arr = item1.setField.split(",");
                            arr.forEach((item2) => {
                                this.$set(this.detaislDataInfo, item2, "");
                            });
                        } else {
                            this.$set(this.detaislDataInfo, item1.entityField, "");
                        }
                    });
                } else if (item.jciType == 3) {
                    this.footForm = JSON.parse(JSON.stringify(item.jurconfigform));
                }
            });
            mainFormList.forEach((key, i) => {
                this.tabForm[i] = JSON.parse(JSON.stringify(key));
                this.tabForm[i].jurconfigform = [];
                var index1 = 0
                for (let index = 0; index < key.jurconfigform.length; index++) {
                    // if (key.jurconfigform[index].isShow == 1)
                    if (key.jurconfigform[index].isShow == 1) {
                        key.jurconfigform[index].isIndex = index1
                        index1++
                    }
                    this.tabForm[i].jurconfigform.push(key.jurconfigform[index]);

                }
            });
            var arr = [{ entityField: "lackregisterAddList" }];
            var obj = this.$common.filterMainFields(
                this.formDataList,
                arr,
                mainFormList[0]
            );
            for (let key in obj) {
                this.$set(this.sendDataInfo, key, obj[key]);
            }
            this.$set(this.sendDataInfo, "lomApptype", 0);
            this.$set(this.sendDataInfo, "actionType", 0);
            this.showTabs = this.tabForm[0].jciName;
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.$nextTick(() => {
            this.openBox();
        });
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() { },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_button_box {
    height: 200px;
    background-color: red;
}

.el-date-editor.el-input,
.el-date-editor.el-input__inner {
    width: 100%;
}

.el-drawer {
    outline: none;
}

/* 表格样式更改*/
#mxTable .el-form-item--mini.el-form-item,
#mxTable .el-form-item--small.el-form-item {
    margin-bottom: 0;
}
</style>